<template>
	<div class="owl-carousel">
		<div class="item" v-for="item in items">
			<!-- <pre>{{item}}</pre> -->
            <div v-if="item.href">
                <a v-if="item.text" :href="item.href" class="sliderTitle">{{item.text}}</a>
            </div>
            <div v-else>
                <p v-if="item.text" class="sliderTitle">{{item.text}}</p>
            </div>

            <p v-if="item.data" class="data">{{item.data}}
            </p>
		</div>
	</div>
</template>

<script>
module.exports = {

	props: ['items'],

	data () {
		return {}
	},

	updated() {
		this.$emit('updated', {
			owlSettings: {
				items: 1,
				loop: this.items.length > 2 ? true : false,
				nav: true,
                margin: 30,
				responsive: {
					0: {
						items: 1,
					},
					640: {
						items: 2,
					}
				}
			}
		});
	}
}
</script>

<style lang="scss" scope=".slider-otherNews">
@import "scss/wanted";
.slider-otherNews {
    .owl-carousel {
        position: relative;
        .item {
            border: 1px solid #e2edf3;
            border-radius: 7px;
            padding: rem(15) rem(19);
            margin-bottom: 7px;
            height: rem(100);
						margin-right: 1px;
            .sliderTitle{
                font-size: rem(14);
				font-weight: 900;
                line-height: rem(22);
                color: black;
                height: rem(44);
                overflow: hidden;
            }
            a.sliderTitle{
                text-decoration: none;
                display: block;
                &:hover{
                    text-decoration: underline;
                }
            }
            .data{
                font-size: rem(12);
                line-height: rem(24);
                color: #7e8183;
                padding-left: 20px;
                background-image: url('../img/calendar.png');
                background-position: left center;
                background-repeat: no-repeat;
            }
        }
        .owl-nav{
            font-size: 0;
            display: flex;
            justify-content:space-between;
            width: 100px;
            position: absolute;
            right: 0;
            bottom: -50px;
            top: auto;
                    z-index: 11;
            @include m_up{
              top: calc(50% - 21px);
              bottom: auto;
              width: 100%;
            };
            div{
                width: 42px;
                height: 42px;
                border-radius: 100%;
                @include single-transition();
                background-size: 25px;
                background-position: center;
                background-repeat: no-repeat;
                background-image: url('../img/arr.svg');
                border: 1px solid black;
                background-color: #fff;
                &:hover{
                    background-image: url('../img/arr2.svg');
					background-color: var(--bg-hover);
					border-color: var(--bg-hover);
                }
            }
            .owl-prev{
                transform: rotate(90deg);
                position: relative;
                left: 0;
              @include m_up{
                left: -68px;
              };
            }
            .owl-next{
                transform: rotate(-90deg);
                position: relative;
                right: 0;
              @include m_up{
                right: -68px;
              };
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// slider-otherNews.vue?286950c2